import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import StyledCheckBoxWrapper from '../../../../style/Safety/DamageReport/StyledCheckBoxWrapper';

const CommonDamageCheckBox = ({ options, onChangeHandler, ...props }) => {
  const { register } = useFormContext();
  const { gapBetweenX } = props;

  const [disabled, setDisabled] = useState(props?.disabled || false);

  useEffect(() => {
    setDisabled(props?.disabled || false);
  }, [props?.disabled]);
  return (
    <div
      className={`w-full flex flex-wrap gap-y-[8px] ${gapBetweenX ?? 'gap-x-[6px]'}`}
    >
      {options?.map(option => (
        <div key={option?.key} className={`${option?.width ?? 'w-[100px]'}`}>
          <div className="flex flex-col justify-end h-full w-full gap-y-[4px]">
            {option?.subLabel && (
              <div className="font-[400] text-[9px] text-[#AAAAAA]">
                {option?.subLabel}
              </div>
            )}
            <div className="w-full flex items-center gap-x-[4px]">
              <input
                type="checkbox"
                className="w-[12px] h-[12px]"
                disabled={disabled}
                defaultChecked={option?.defaultValue || false}
                {...register(option?.inputName, {
                  onChange: e =>
                    onChangeHandler && onChangeHandler({ e, option, ...props }),
                })}
              />
              <StyledCheckBoxWrapper>{option?.label}</StyledCheckBoxWrapper>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CommonDamageCheckBox;
